import { TrText } from "../components/TrText";
import { TrSpace } from "../components/TrSpace";
import { TrUnChangebleTextField } from "../components/TrUnChangebleTextField";
import { FormPageButton } from "../components/FormPageButton";
import { push } from "connected-react-router";
import { useSelector } from "react-redux";
import { getAddress, getApartmentAndRoom, getCity, getFurigana, getPostCode, getPrefecture, getReceiver, getTelephone } from "../reducks/shippingInfo/selectors";
import { useDispatch } from "react-redux";

export const ConfirmShippingInfo = () => {
    const dispatch = useDispatch()
    const selector = useSelector(state => state)
    
    // shippingInfo state
    const receiver = getReceiver(selector)
    const furigana = getFurigana(selector)
    const telephone = getTelephone(selector)
    const postCode = getPostCode(selector)
    const prefecture = getPrefecture(selector)
    const city = getCity(selector)
    const address = getAddress(selector)
    const apartmentAndRoom = getApartmentAndRoom(selector)

    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>発送先情報の再確認</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="iPad/iPadMini:w-11/12 md:w-6/12">
                            <tbody>
                                <TrText text="お名前"/>
                                <TrUnChangebleTextField id="confirm-receiver-name" placeholder="お名前" value={receiver}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="お名前（フリガナ）"/>
                                <TrUnChangebleTextField id="confirm-receiver-kana-name" placeholder="お名前（フリガナ）" value={furigana}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="電話番号"/>
                                <TrUnChangebleTextField id="confirm-tel" placeholder="電話番号" value={telephone}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="郵便番号"/>
                                <TrUnChangebleTextField id="confirm-post-code" placeholder="郵便番号" value={postCode}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="都道府県"/>
                                <TrUnChangebleTextField id="confirm-prefecture" placeholder="都道府県" value={prefecture}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="市町村"/>
                                <TrUnChangebleTextField id="confirm-city" placeholder="市町村" value={city}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="番地"/>
                                <TrUnChangebleTextField id="confirm-address" placeholder="番地" value={address}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="マンション名・号室"/>
                                <TrUnChangebleTextField id="confirm-apartment-and-room" placeholder="マンション名・号室" value={apartmentAndRoom}/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <FormPageButton text="次へ進む" onClick={() => {
                            // Stripe Custom CheckoutのDebug
                            dispatch(push('/custom-checkout'));
                        }}/>
                    </div>
                </main>
        </div>
    );
};